import { Button, Stack } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";

import { approveScopeDocument } from "api";

import { CheckIcon } from "assets";

import { ApproveDialog, SelectionCounter, useDialogControls } from "components";

import { useNotify } from "hooks";

import { QUERY_KEYS } from "consts";

import { useSetDefaultMatchedDocumentsSelection, useUserRole } from "recoils";

export const EmissionApproveActions: React.FunctionComponent<{
  rowSelection: any;
  setrowSelection: any;
}> = ({ rowSelection, setrowSelection }) => {
  const notify = useNotify();
  const userRole = useUserRole();
  const queryClient = useQueryClient();
  const setDefaultSelection = useSetDefaultMatchedDocumentsSelection();
  const deleteDialogControls = useDialogControls();
  const { mutateAsync: approveUploadedDocument } =
    useMutation(approveScopeDocument);
  // const selected = useSelectedMatchedDocuments();

  const selected: any[] = [];

  selected.push(...Object.keys(rowSelection));

  const onApproveClick = () => {
    Promise.allSettled(
      selected.map((id) =>
        approveUploadedDocument(id, {
          onError: () =>
            notify.error(
              `Some error has happen while approving documents: ${id}!`,
            ),
          onSuccess: () => {
            notify.success("Selected documents were approved!");
            setrowSelection();
          },
        }),
      ),
    ).finally(() => {
      deleteDialogControls.close();
      setDefaultSelection();
      queryClient.invalidateQueries([QUERY_KEYS.DOCUMENTS]);
    });
  };

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <SelectionCounter selectedElements={selected.length} />

      <Button
        startIcon={<CheckIcon />}
        variant="outlined"
        disabled={selected.length === 0 || userRole.isAuditor}
        onClick={deleteDialogControls.open}
      >
        Approve
      </Button>

      <ApproveDialog
        isOpen={deleteDialogControls.isOpen}
        onCancel={deleteDialogControls.close}
        onAppoveClick={onApproveClick}
        title="Approve emission factors?"
        selectedCount={selected.length}
      />
    </Stack>
  );
};
